import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
} from "@mui/material";
import { useCallback, useState, useEffect } from "react";
import HelpButton from "../../../Buttons/HelpButton/HelpButton";

const CalculationMethodSelector = ({
  disabled,
  onChange,
  value,
  helpButtonContent,
  modalContent,
  defaultCalculationMethod,
  titleText,
  calculationMethods,
  isModalOpen,
}) => {
  const [calculationMethod, setCalculationMethod] = useState(
    defaultCalculationMethod
  );
  const [isHelpButtonOpen, setIsHelpButtonOpen] = useState(false);

  useEffect(() => {
    value && setCalculationMethod(value);
  }, [value]);

  useEffect(() => {
    setIsHelpButtonOpen((prev) => prev && !isModalOpen);
  }, [isModalOpen]);

  const handleCalculationMethodChange = useCallback(
    (e) => {
      const newCalculationMethod = e.target.value;
      setCalculationMethod(newCalculationMethod);
      onChange && onChange(newCalculationMethod);
    },
    [onChange]
  );

  const handleHelpButtonOpen = useCallback(() => {
    !isModalOpen && setIsHelpButtonOpen(true);
  }, [isModalOpen]);

  const handleHelpButtonClose = useCallback(() => {
    setIsHelpButtonOpen(false);
  }, []);

  return (
    calculationMethods &&
    titleText && (
      <>
        <Stack sx={{ mt: 3, gap: 2 }} direction="row" alignItems="center">
          <Typography variant="h6">{titleText}</Typography>
          {helpButtonContent && (
            <HelpButton
              value={isHelpButtonOpen}
              onOpen={handleHelpButtonOpen}
              onClose={handleHelpButtonClose}
            >
              {helpButtonContent}
            </HelpButton>
          )}
          {modalContent}
        </Stack>
        <RadioGroup
          row
          value={calculationMethod}
          onChange={handleCalculationMethodChange}
        >
          {calculationMethods.map((method) => (
            <FormControlLabel
              key={method.value}
              value={method.value}
              control={<Radio />}
              label={method.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </>
    )
  );
};

export default CalculationMethodSelector;
